import { useEffect } from 'react';
import { hasAdminRole, hasOnboarderRole, hasValidatorRole } from 'utils/rolesUtils';
import { useCurrentRole, useCurrentUser } from '../../hooks/slices';
import { tracker } from './tracker';
import { getOrganizationRoleResourceTypeKey, roleToCustomerIoIdentifier } from './trackingUtils';

// This hooks is used to (re)initialize the user tracking.
// thanks to its two dependencies, it is expected to run in the following cases:
// - App init with a user already logged in
// - User login
// - Role switch
// - Impersonation
// - de-impersonation
export const useInitializeUserTracking = () => {
  const currentUser = useCurrentUser();
  const currentRole = useCurrentRole();

  return useEffect(() => {
    if (currentUser) {
      const { roles } = currentUser;
      const kind = hasAdminRole(roles)
        ? 'admin'
        : hasValidatorRole(roles)
          ? 'validator'
          : hasOnboarderRole(roles)
            ? 'onboarder'
            : 'regular_user';

      tracker.identify(currentUser.id, {
        ...(currentRole && {
          [getOrganizationRoleResourceTypeKey(currentRole.resource_type)]: currentRole.resource_id,
        }),
        role: currentRole?.kind,
        email: currentUser.email,
        firstName: currentUser.first_name,
        lastName: currentUser.last_name,
        kind,
      });
      if (currentRole) {
        tracker.group(roleToCustomerIoIdentifier(currentRole), {
          name: currentRole.resource.name,
          ...('email' in currentRole.resource && { email: currentRole.resource.email }),
          [getOrganizationRoleResourceTypeKey(currentRole.resource_type)]: currentRole.resource_id,
        });
      }
    }
  }, [currentUser, currentRole]);
};
